function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoPetrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be650677-56a3-460d-83e7-952f44ab80fb",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2446.13 881.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_petrol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 2446.13,
    height: 881.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.45,577.14V521.23q47.73,15,84.47,15,50.73,0,50.72-26.8a21.82,21.82,0,0,0-7.39-16.78q-7.56-7.21-38.72-20-55.89-23-72.85-39.18-22-21.39-22-54,0-42,32-64,31.62-21.81,82.42-21.79,28,0,81,10.31v53.78q-39.43-15.75-73.24-15.74-47.62,0-47.62,26.19,0,9.8,9.6,16,8,5,44,21.2,51.81,23,69,40,20.4,20.18,20.41,52.2,0,46-40,70.19-32.4,19.62-84,19.58a385.75,385.75,0,0,1-87.8-10.29Z",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.91 298.64 555.91 298.64 634.98 298.64 634.98 581.71 555.91 581.71 555.91 298.64",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "707.5 581.71 707.5 298.64 910.29 298.64 910.29 349.84 783.7 349.84 783.7 413.76 893.89 413.76 893.89 460.46 783.7 460.46 783.7 527.64 913.55 527.64 913.55 581.71 707.5 581.71 707.5 581.71",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "965.17 581.71 965.17 298.64 1067.69 298.64 1138.91 479.5 1211.92 298.64 1309.3 298.64 1309.3 581.71 1234.32 581.71 1234.32 381.29 1151.31 584.59 1102.3 584.59 1020.88 381.29 1020.88 581.71 965.17 581.71 965.17 581.71",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1381.83 581.71 1381.83 298.64 1584.62 298.64 1584.62 349.84 1458.03 349.84 1458.03 413.76 1568.22 413.76 1568.22 460.46 1458.03 460.46 1458.03 527.64 1587.89 527.64 1587.89 581.71 1381.83 581.71 1381.83 581.71",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1639.93 581.71 1639.93 298.64 1731.57 298.64 1828.79 488.14 1828.79 298.64 1884.48 298.64 1884.48 581.71 1795.45 581.71 1695.64 389.67 1695.64 581.71 1639.93 581.71 1639.93 581.71",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940.62,577.14V521.23q47.31,15,84.47,15,50.73,0,50.72-26.8a22.21,22.21,0,0,0-7.17-16.78q-7.6-7.21-38.93-20-55.73-22.77-72.86-39.18-22-21.21-21.95-54.17,0-41.81,32-63.79,31.58-21.81,82.43-21.79,28.56,0,74,9.1l7,1.21v53.78q-39.45-15.75-73.44-15.74-47.44,0-47.4,26.19c0,6.53,3.17,11.86,9.57,16q7.59,4.81,44.19,21.2,51.43,23,68.78,40,20.43,20.18,20.41,52.2,0,46-39.79,70.19-32.58,19.62-84.19,19.58a385.47,385.47,0,0,1-87.82-10.29Z",
    style: {
      fill: "#00aaad",
      fillRule: "evenodd"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPetrol);
export default __webpack_public_path__ + "static/media/logo_petrol.b36791a6786fa84e4b56570fa019a84c.svg";
export { ForwardRef as ReactComponent };